import { useQuery } from "@tanstack/react-query";
import { useORPCQuery } from "Core/oRPC";
import { useMemo } from "react";
import { useEnvironment } from "Shared/Hooks";
import { universalSearchResultItem } from "Store/UniversalSearchStore";
import { normalizeTrendingPath } from "./useSearchTopTrends.utils";

export const useSearchTopTrends = (loggedIn?: boolean) => {
    const { ospMetricsApi } = useORPCQuery();
    const { isSovereign } = useEnvironment();
    const { data: rawTrendingSearchesData } = useQuery(
        ospMetricsApi.getSearchTopTrends.queryOptions({
            staleTime: 3600000,
            enabled: loggedIn && !isSovereign
        })
    );

    const trendingSearchesData: universalSearchResultItem[] = useMemo(() => {
        if (!rawTrendingSearchesData?.Tables?.[0]?.Rows) {
            return [];
        }

        const columns = rawTrendingSearchesData.Tables[0].Columns;
        if (!columns) {
            return [];
        }

        const titleIndex = columns.findIndex((col) => col.Name === "resultItemTitle");
        const pathIndex = columns.findIndex((col) => col.Name === "Path");
        const categoryIndex = columns.findIndex((col) => col.Name === "Category");
        const descriptionIndex = columns.findIndex((col) => col.Name === "Description");

        return rawTrendingSearchesData.Tables[0].Rows.map((row) => {
            const fullPath = pathIndex >= 0 ? String(row[pathIndex] || "") : "";

            const navigationPath = normalizeTrendingPath(fullPath);

            const item: universalSearchResultItem = {
                id: String(row[titleIndex] !== undefined ? row[titleIndex] : row[0] || ""),
                title: String(row[titleIndex] !== undefined ? row[titleIndex] : row[0] || ""),
                description: descriptionIndex >= 0 ? String(row[descriptionIndex] || "") : "",
                navigationTarget: navigationPath,
                category: "Trending Searches",
                originalCategory: categoryIndex >= 0 ? String(row[categoryIndex] || "") : "Trending Searches",
                appPath: pathIndex >= 0 ? String(row[pathIndex] || "") : undefined
            };

            return item;
        });
    }, [rawTrendingSearchesData]);

    return {
        trendingSearchesData
    };
};
